import type {
  ConnectedCallUsecase,
  ConnectedCallWithCrmOpsRequest,
} from '@usecases/connected-call.usecase';

import type { BaseController } from '@infra/controllers/base.controller';

export type ConnectedCallControllerInput =
  ConnectedCallWithCrmOpsRequest | void;

export type ConnectedCallControllerOutput = void;

export class ConnectedCallController
  implements
    BaseController<ConnectedCallControllerInput, ConnectedCallControllerOutput>
{
  constructor(private usecase: ConnectedCallUsecase) {}

  async handle(
    input: ConnectedCallControllerInput,
  ): Promise<ConnectedCallControllerOutput> {
    await this.usecase.run(input);
  }
}
